// =====================================================
// STAR MAP CONFIGURATOR v2 — Kurigadget
// • 2851 stelle BSC reali
// • 88 costellazioni IAU complete
// • Via Lattea a 5 layer
// • Animazioni: fade-in, twinkle, parallax, morphing forme
// =====================================================
// Wrapped in an IIFE to avoid global scope conflicts
// (theme already defines COLORS, SHAPES, state, etc.)
(function() {
'use strict';

// ---------- STATE ----------
const state = {
  location: { name: 'Roma, Italia', lat: 41.9028, lon: 12.4964 },
  date: { day: 15, month: 6, year: 2024, hour: null, minute: null },
  shape: 'circle',
  color: 'dark',
  viewMode: 'local', // 'local' = mag<=4 cielo pulito | 'global' = mag<=5.5 cielo ricco
  options: {
    constellations: true,
    constellationNames: false,
    grid: false,
    milkyWay: false,
    twinkle: false,
    showCoords: true,
  },
  title: 'IL PRIMO INCONTRO',
  product: 'poster',
  size: '50x70',
  frameColor: 'naturale', // 'naturale' | 'bianco' | 'nero' (solo per framed)
};

// Soglie magnitudine per le due viste
const MAG_LIMITS = { local: 3.8, global: 5.5 };

// ---------- PRICING ----------
// Fallback statico. In Shopify, window.STARMAP_PRICING viene popolato da Liquid
// con i prezzi REALI delle varianti — si aggiorna automaticamente se cambi
// i prezzi in Shopify Admin.
const PRICING_FALLBACK = {
  poster: { '30x40': 29.99, '45x60': 39.99, '50x70': 49.99, '60x80': 59.99 },
  framed: { '30x40': 59.99, '45x60': 74.99, '50x70': 89.99, '60x80': 109.99 },
  metal:  { '30x40': 99.99, '45x60': 124.99, '50x70': 149.99, '60x80': 179.99 },
};
function getPricing() {
  const shopifyPricing = (typeof window !== 'undefined') ? window.STARMAP_PRICING : null;
  if (shopifyPricing && shopifyPricing.poster && Object.keys(shopifyPricing.poster).length > 0) {
    // Merge: usa Shopify dove disponibile, fallback altrove
    return {
      poster: Object.assign({}, PRICING_FALLBACK.poster, shopifyPricing.poster || {}),
      framed: Object.assign({}, PRICING_FALLBACK.framed, shopifyPricing.framed || {}),
      metal:  Object.assign({}, PRICING_FALLBACK.metal,  shopifyPricing.metal  || {}),
    };
  }
  return PRICING_FALLBACK;
}
const PRICING = new Proxy({}, {
  get(_, prop) {
    return getPricing()[prop];
  },
  ownKeys() {
    return Object.keys(getPricing());
  },
  getOwnPropertyDescriptor() {
    return { enumerable: true, configurable: true };
  },
});

// ---------- COLORS ----------
const COLORS = [
  { id: 'dark',     swatch: '#0a0e27' },
  { id: 'kuri-red', swatch: '#3a0a0a' },
  { id: 'bordeaux', swatch: '#3d0f1b' },
  { id: 'navy',     swatch: '#0d1b2a' },
  { id: 'black',    swatch: '#000000' },
  { id: 'teal',     swatch: '#134e4a' },
  { id: 'purple',   swatch: '#2d1b4e' },
  { id: 'gray',     swatch: '#4b5563' },
  { id: 'cream',    swatch: '#f5f0e6' },
];

// ---------- SHAPES ----------
const SHAPES = [
  { id: 'circle', label: 'Cerchio', scene: false, cardClass: '',
    icon: '<svg viewBox="0 0 40 40" fill="none"><circle cx="20" cy="14" r="11" fill="#0a0e27"/><path d="M20,11 20.75,13.25 23,14 20.75,14.75 20,17 19.25,14.75 17,14 19.25,13.25Z" fill="white"/><path d="M12.5,8.2 12.95,9.55 14.3,10 12.95,10.45 12.5,11.8 12.05,10.45 10.7,10 12.05,9.55Z" fill="white" opacity="0.8"/><path d="M28,10.2 28.325,11.175 29.3,11.5 28.325,11.825 28,12.8 27.675,11.825 26.7,11.5 27.675,11.175Z" fill="white" opacity="0.7"/><path d="M15,20.7 15.325,21.675 16.3,22 15.325,22.325 15,23.3 14.675,22.325 13.7,22 14.675,21.675Z" fill="white" opacity="0.7"/><path d="M26,17.9 26.275,18.725 27.1,19 26.275,19.275 26,20.1 25.725,19.275 24.9,19 25.725,18.725Z" fill="white" opacity="0.6"/><rect x="8" y="28" width="24" height="1.8" rx="0.9" fill="#b8b8b8"/><rect x="11" y="32" width="18" height="1.5" rx="0.75" fill="#b8b8b8" opacity="0.7"/><rect x="14" y="36" width="12" height="1.5" rx="0.75" fill="#b8b8b8" opacity="0.5"/></svg>' },
  { id: 'heart', label: 'Cuore', scene: false, cardClass: '',
    icon: '<svg viewBox="0 0 40 40" fill="none"><path d="M20 27C9 19.5 7.5 10 10 7C12 4.5 15.5 4 17.5 7C19 9 20 11 20 11C20 11 21 9 22.5 7C24.5 4 28 4.5 30 7C32.5 10 31 19.5 20 27Z" fill="#0a0e27"/><path d="M20,12 20.75,14.25 23,15 20.75,15.75 20,18 19.25,15.75 17,15 19.25,14.25Z" fill="white"/><path d="M13,10.2 13.45,11.55 14.8,12 13.45,12.45 13,13.8 12.55,12.45 11.2,12 12.55,11.55Z" fill="white" opacity="0.8"/><path d="M27,9.7 27.45,11.05 28.8,11.5 27.45,11.95 27,13.3 26.55,11.95 25.2,11.5 26.55,11.05Z" fill="white" opacity="0.75"/><path d="M18.5,22.4 18.775,23.225 19.6,23.5 18.775,23.775 18.5,24.6 18.225,23.775 17.4,23.5 18.225,23.225Z" fill="white" opacity="0.65"/><rect x="8" y="28" width="24" height="1.8" rx="0.9" fill="#b8b8b8"/><rect x="11" y="32" width="18" height="1.5" rx="0.75" fill="#b8b8b8" opacity="0.7"/><rect x="14" y="36" width="12" height="1.5" rx="0.75" fill="#b8b8b8" opacity="0.5"/></svg>' },
  { id: 'frameless', label: 'Sfondo', scene: false, cardClass: 'card-dark',
    icon: '<svg viewBox="0 0 40 40" fill="none"><path d="M23,9.5 24.125,12.875 27.5,14 24.125,15.125 23,18.5 21.875,15.125 18.5,14 21.875,12.875Z" fill="currentColor"/><path d="M13,5.2 13.7,7.3 15.8,8 13.7,8.7 13,10.8 12.3,8.7 10.2,8 12.3,7.3Z" fill="currentColor"/><path d="M11,16.2 11.7,18.3 13.8,19 11.7,19.7 11,21.8 10.3,19.7 8.2,19 10.3,18.3Z" fill="currentColor"/><path d="M29,10.1 29.475,11.525 30.9,12 29.475,12.475 29,13.9 28.525,12.475 27.1,12 28.525,11.525Z" fill="currentColor" opacity="0.9"/><path d="M29,17 29.5,18.5 31,19 29.5,19.5 29,21 28.5,19.5 27,19 28.5,18.5Z" fill="currentColor" opacity="0.9"/><circle cx="22" cy="4" r="1.1" fill="currentColor"/><circle cx="29" cy="8" r="1" fill="currentColor" opacity="0.85"/><circle cx="7" cy="14" r="1.2" fill="currentColor" opacity="0.8"/><circle cx="30" cy="18" r="1" fill="currentColor" opacity="0.75"/><circle cx="21" cy="23" r="1.1" fill="currentColor" opacity="0.7"/><rect x="10" y="29.5" width="20" height="2.5" rx="1.25" fill="currentColor" opacity="0.85"/><rect x="12" y="33.5" width="16" height="2" rx="1" fill="currentColor" opacity="0.65"/><rect x="14.5" y="37" width="11" height="2" rx="1" fill="currentColor" opacity="0.45"/></svg>' },
  { id: 'fullsky', label: 'Infinito', scene: true, cardClass: 'card-dark',
    icon: '<svg viewBox="0 0 40 40" fill="none"><path d="M20,13 C21.5,8 31.5,8 33,13 C34.5,18 24,19 20,13 C18.5,8 8.5,8 7,13 C5.5,18 16,19 20,13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20" cy="3" r="1.1" fill="currentColor"/><path d="M12.5,4.2 12.95,5.55 14.3,6 12.95,6.45 12.5,7.8 12.05,6.45 10.7,6 12.05,5.55Z" fill="currentColor"/><path d="M27.5,3.8 28.05,5.45 29.7,6 28.05,6.55 27.5,8.2 26.95,6.55 25.3,6 26.95,5.45Z" fill="currentColor"/><circle cx="31" cy="9" r="1" fill="currentColor" opacity="0.85"/><circle cx="7" cy="11" r="1.1" fill="currentColor" opacity="0.8"/><path d="M11,17.5 11.625,19.375 13.5,20 11.625,20.625 11,22.5 10.375,20.625 8.5,20 10.375,19.375Z" fill="currentColor"/><circle cx="18" cy="21.5" r="1" fill="currentColor" opacity="0.75"/><path d="M28,18.7 28.45,20.05 29.8,20.5 28.45,20.95 28,22.3 27.55,20.95 26.2,20.5 27.55,20.05Z" fill="currentColor" opacity="0.9"/><rect x="10" y="27" width="20" height="2.5" rx="1.25" fill="currentColor" opacity="0.7"/><rect x="12" y="31" width="16" height="2" rx="1" fill="currentColor" opacity="0.5"/><rect x="15" y="35" width="10" height="2" rx="1" fill="currentColor" opacity="0.35"/></svg>' },
  { id: 'sunset',  label: 'Tramonto',    scene: true, cardClass: 'card-scene', icon: '' },
  { id: 'couple',  label: 'Coppia',      scene: true, cardClass: 'card-scene', icon: '' },
];

// ---------- ITALIAN MONTHS ----------
const MONTHS_IT = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

// ---------- DATA (loaded async) ----------
let STARS = [];
let CONSTELLATION_LINES = [];
let CONSTELLATION_NAMES = [];

// Animation state
let animationState = {
  starOpacity: 0,        // 0→1 fade-in
  fadingIn: false,
  twinklePhases: [],     // per-star random phase
  shapeMorph: 1,         // 0→1 morphing progress
  fromShape: 'circle',
  toShape: 'circle',
  morphing: false,
  parallaxX: 0,
  parallaxY: 0,
  starFading: false,     // true durante il fade-out stelle (cambio forma)
  starFadeOpacity: 1,    // 1→0 durante fade-out
};

// =====================================================
// SCENE MODE — imposta poster full-bleed per sunset/photo
// =====================================================
function applySceneMode() {
  const poster = document.getElementById('poster');
  const canvas = document.getElementById('sky');
  const isScene = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');
  const isFrameless = (state.shape === 'frameless');

  if (isScene) {
    poster.classList.add('scene');
    poster.classList.remove('frameless');
    poster.style.background = '#000';
    canvas.width = 380;
    canvas.height = 570;
    poster.classList.toggle('shape-sunset', state.shape === 'sunset');
    poster.classList.toggle('shape-couple', state.shape === 'couple');
    poster.classList.toggle('shape-fullsky', state.shape === 'fullsky');
  } else if (isFrameless) {
    poster.classList.remove('scene', 'shape-sunset', 'shape-couple', 'shape-fullsky');
    poster.classList.add('frameless');
    poster.style.background = '';
    canvas.width = 300;
    canvas.height = 300;
  } else {
    poster.classList.remove('scene', 'frameless', 'shape-sunset', 'shape-couple', 'shape-fullsky');
    poster.style.background = '';
    canvas.width = 300;
    canvas.height = 300;
  }

  // Nascondi colori e "Vista del cielo" per scene foto (sunset/couple).
  // Devo usare setProperty con 'important' perché il CSS nuclear reset
  // forza display: block !important sui .field.
  const hideForScene = (state.shape === 'sunset' || state.shape === 'couple');

  const colorField = document.getElementById('colorGrid')?.closest('.field');
  if (colorField) {
    if (hideForScene) {
      colorField.style.setProperty('display', 'none', 'important');
    } else {
      colorField.style.removeProperty('display');
    }
  }

  const viewmodeField = document.querySelector('#starmapApp .viewmode-group')?.closest('.field');
  if (viewmodeField) {
    if (hideForScene) {
      viewmodeField.style.setProperty('display', 'none', 'important');
    } else {
      viewmodeField.style.removeProperty('display');
    }
  }

  // Nascondi "Griglia coordinate" su scene mode (non ha senso visivamente
  // sopra una foto). Costellazioni resta visibile.
  const gridCard = document.getElementById('cardGrid');
  if (gridCard) {
    if (hideForScene) {
      gridCard.style.setProperty('display', 'none', 'important');
    } else {
      gridCard.style.removeProperty('display');
    }
  }

  // Nascondi il toggle "Mostra coordinate sulla stampa" quando la forma è Infinito
  // (fullsky non ha un titolo standard ma copre tutto il cielo, le coordinate
  // del luogo specifico perdono significato visivo).
  const showCoordsInput = document.getElementById('showCoords');
  const coordsField = showCoordsInput ? showCoordsInput.closest('.field') : null;
  if (coordsField) {
    if (state.shape === 'fullsky') {
      coordsField.style.setProperty('display', 'none', 'important');
    } else {
      coordsField.style.removeProperty('display');
    }
  }

  // Forza ricalcolo posizioni stelle
  lastDateKey = '';
}

// =====================================================
// INITIALIZATION
// =====================================================
async function init() {
  populateDateSelectors();
  populateStylesAndColors();
  attachEventListeners();
  setupMap();
  loadSceneImages();
  await loadAstronomyData();
  applySceneMode();
  startRenderLoop();
  // Trigger entrance animation
  setTimeout(() => {
    document.getElementById('poster').classList.remove('entering');
    document.getElementById('poster').classList.add('entered');
    animationState.fadingIn = true;
  }, 100);
}

async function loadAstronomyData() {
  try {
    const ASSETS = window.STARMAP_ASSETS || {};
    const [starsRes, linesRes, namesRes] = await Promise.all([
      fetch(ASSETS.stars || 'stars_compact.json'),
      fetch(ASSETS.constellation_lines || 'constellations_lines_compact.json'),
      fetch(ASSETS.constellation_names || 'constellation_names_compact.json'),
    ]);
    STARS = await starsRes.json();
    CONSTELLATION_LINES = await linesRes.json();
    CONSTELLATION_NAMES = await namesRes.json();
    
    // Pre-generate twinkle phases for all stars
    animationState.twinklePhases = STARS.map(() => Math.random() * Math.PI * 2);
    
    console.log(`Loaded: ${STARS.length} stars, ${CONSTELLATION_LINES.length} constellations`);
  } catch (e) {
    console.error('Failed to load astronomy data:', e);
  }
}

function populateDateSelectors() {
  const day = document.getElementById('day');
  const month = document.getElementById('month');
  const year = document.getElementById('year');
  const hour = document.getElementById('hour');
  const minute = document.getElementById('minute');
  
  for (let i = 1; i <= 31; i++) {
    day.innerHTML += `<option value="${i}" ${i===state.date.day?'selected':''}>${i}</option>`;
  }
  MONTHS_IT.forEach((m, i) => {
    month.innerHTML += `<option value="${i+1}" ${i+1===state.date.month?'selected':''}>${m}</option>`;
  });
  for (let y = 2030; y >= 1950; y--) {
    year.innerHTML += `<option value="${y}" ${y===state.date.year?'selected':''}>${y}</option>`;
  }
  hour.innerHTML = '<option value="">--</option>';
  for (let h = 0; h < 24; h++) {
    hour.innerHTML += `<option value="${h}">${String(h).padStart(2,'0')}</option>`;
  }
  minute.innerHTML = '<option value="">--</option>';
  for (let m = 0; m < 60; m += 5) {
    minute.innerHTML += `<option value="${m}">${String(m).padStart(2,'0')}</option>`;
  }
}

function populateStylesAndColors() {
  const styleGrid = document.getElementById('styleGrid');
  SHAPES.forEach(s => {
    const card = document.createElement('div');
    card.className = 'style-card' + (s.id === state.shape ? ' active' : '');
    card.dataset.shape = s.id;
    if (s.cardClass) card.classList.add(s.cardClass);
    if (s.cardClass === 'card-scene') {
      const ASSETS = window.STARMAP_ASSETS || {};
      const fallback = s.id === 'sunset' ? 'sunset_real.jpg' : 'couple_real.jpg';
      const src = s.id === 'sunset' ? (ASSETS.sunset || fallback) : (ASSETS.couple || fallback);
      card.innerHTML = `<img class="scene-thumb" src="${src}" alt="">`;
    } else {
      card.innerHTML = s.icon;
    }
    card.addEventListener('click', () => {
      if (s.id === state.shape) return;
      document.querySelectorAll('[data-shape]').forEach(e => e.classList.remove('active'));
      card.classList.add('active');
      // Fade-out stelle, poi cambia forma, poi fade-in
      animationState.starFading = true;
      animationState.starFadeOpacity = 1;
      const nextShape = s.id;
      setTimeout(() => {
        const isSceneTo = (nextShape === 'sunset' || nextShape === 'couple' || nextShape === 'fullsky');
        const isSceneFrom = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');
        if (!(isSceneTo || isSceneFrom)) {
          animationState.fromShape = state.shape;
          animationState.toShape = nextShape;
          animationState.shapeMorph = 0;
          animationState.morphing = true;
        } else {
          animationState.morphing = false;
          animationState.shapeMorph = 1;
        }
        state.shape = nextShape;
        applySceneMode();
        animationState.starFading = false;
        animationState.starFadeOpacity = 1;
        animationState.starOpacity = 0;
        animationState.fadingIn = true;
      }, 250);
    });
    styleGrid.appendChild(card);
  });
  
  const colorGrid = document.getElementById('colorGrid');
  COLORS.forEach(c => {
    const sw = document.createElement('div');
    sw.className = 'color-swatch' + (c.id === state.color ? ' active' : '');
    sw.dataset.color = c.id;
    // Use setProperty with !important to beat theme CSS overrides
    sw.style.setProperty('background', c.swatch, 'important');
    sw.style.setProperty('background-color', c.swatch, 'important');
    sw.title = c.id;
    sw.addEventListener('click', () => {
      document.querySelectorAll('[data-color]').forEach(e => e.classList.remove('active'));
      sw.classList.add('active');
      state.color = c.id;
      updatePosterClass();
    });
    colorGrid.appendChild(sw);
  });
}

// =====================================================
// EVENT LISTENERS
// =====================================================
function attachEventListeners() {
  // Step navigation
  document.querySelectorAll('.step-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.step-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const step = btn.dataset.step;
      document.querySelectorAll('.step-panel').forEach(p => {
        p.style.display = p.dataset.step === step ? 'block' : 'none';
      });
    });
  });
  
  // Date selectors
  ['day','month','year','hour','minute'].forEach(id => {
    document.getElementById(id).addEventListener('change', e => {
      state.date[id] = e.target.value === '' ? null : parseInt(e.target.value);
      updateMeta();
    });
  });
  
  // Title
  document.getElementById('titleText').addEventListener('input', e => {
    state.title = e.target.value;
    document.getElementById('posterTitle').textContent = e.target.value;
  });

  // Dedication
  document.getElementById('dedicationText').addEventListener('input', e => {
    document.getElementById('posterDedication').textContent = e.target.value;
  });
  
  // View mode (locale / globale)
  document.querySelectorAll('[data-viewmode]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('[data-viewmode]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.viewMode = btn.dataset.viewmode;
    });
  });
  
  // Toggles (ridotti: solo costellazioni e griglia)
  ['showConstellations','showGrid'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('change', e => {
      const map = {
        showConstellations: 'constellations',
        showGrid: 'grid',
      };
      state.options[map[id]] = e.target.checked;
    });
  });
  
  document.getElementById('showCoords').addEventListener('change', e => {
    state.options.showCoords = e.target.checked;
    const dispVal = e.target.checked ? '' : 'none';
    document.getElementById('metaCoords').style.display = dispVal;
    const sep = document.querySelector('.meta-sep');
    if (sep) sep.style.display = dispVal;
  });
  
  // Location search with debounce
  let searchTimeout;
  document.getElementById('locationInput').addEventListener('input', e => {
    clearTimeout(searchTimeout);
    const q = e.target.value.trim();
    if (q.length < 3) {
      document.getElementById('locationSuggestions').classList.remove('show');
      return;
    }
    searchTimeout = setTimeout(() => searchLocation(q), 350);
  });
  
  // Hide suggestions on outside click
  document.addEventListener('click', e => {
    if (!e.target.closest('.location-search')) {
      document.getElementById('locationSuggestions').classList.remove('show');
    }
  });

  // Scroll-to-top quando l'utente clicca opzioni visive (per vedere subito la preview)
  // Triggered su: Forma (style-card), Colore (color-swatch), Vista del cielo (viewmode-btn),
  // Personalizza il cielo (icon-card), Tipo prodotto (product-card).
  // Esclusi: Data, Orario, Luogo, Titolo, Dedica, Toggle coordinate, Dimensione.
  const SCROLL_TRIGGER_SELECTOR = '.style-card, .color-swatch, .viewmode-btn, .icon-card';
  document.querySelectorAll(SCROLL_TRIGGER_SELECTOR).forEach(el => {
    el.addEventListener('click', () => {
      // Su mobile scrolla la pagina al poster; su desktop scrolla la sidebar al top
      const isMobile = window.matchMedia('(max-width: 900px)').matches;
      if (isMobile) {
        const preview = document.querySelector('#starmapApp .preview');
        if (preview) preview.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const sidebar = document.querySelector('#starmapApp .sidebar-content');
        if (sidebar) sidebar.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });
  
  // Product type — con collapse pattern (dopo selezione, mostra solo la card attiva)
  document.querySelectorAll('[data-product]').forEach(el => {
    el.addEventListener('click', () => {
      // Se la lista è collapsed e clicco la card già attiva, non fare nulla
      const productList = document.getElementById('productList');
      if (productList && productList.classList.contains('collapsed') && el.classList.contains('active')) {
        return;
      }
      document.querySelectorAll('[data-product]').forEach(e => e.classList.remove('active'));
      el.classList.add('active');
      state.product = el.dataset.product;
      // Collapse: nasconde le altre card
      if (productList) productList.classList.add('collapsed');
      const changeBtn = document.getElementById('changeProductBtn');
      if (changeBtn) changeBtn.style.display = 'inline-flex';
      toggleFrameColorField();
      updatePosterFrame();
      updatePrice();
    });
  });

  // "Cambia" button → riapre tutte le 3 card
  const changeBtn = document.getElementById('changeProductBtn');
  if (changeBtn) {
    changeBtn.addEventListener('click', () => {
      const productList = document.getElementById('productList');
      if (productList) productList.classList.remove('collapsed');
      changeBtn.style.display = 'none';
    });
  }

  // Size
  document.querySelectorAll('[data-size]').forEach(el => {
    el.addEventListener('click', () => {
      document.querySelectorAll('[data-size]').forEach(e => e.classList.remove('active'));
      el.classList.add('active');
      state.size = el.dataset.size;
      updatePrice();
    });
  });

  // Frame color
  document.querySelectorAll('[data-frame-color]').forEach(el => {
    if (el.dataset.frameColor === state.frameColor) el.classList.add('active');
    el.addEventListener('click', () => {
      document.querySelectorAll('[data-frame-color]').forEach(e => e.classList.remove('active'));
      el.classList.add('active');
      state.frameColor = el.dataset.frameColor;
      updatePosterFrame();
    });
  });
  // Init visibility e cornice
  toggleFrameColorField();
  updatePosterFrame();
  updateDeliveryDates();
  
  // Map modal
  document.getElementById('openMapBtn').addEventListener('click', () => {
    document.getElementById('mapModal').classList.add('show');
    setTimeout(() => mapInstance.invalidateSize(), 100);
  });
  document.getElementById('closeMap').addEventListener('click', () => {
    document.getElementById('mapModal').classList.remove('show');
  });
  document.getElementById('confirmCoords').addEventListener('click', () => {
    state.location.name = `${state.location.lat.toFixed(2)}°, ${state.location.lon.toFixed(2)}°`;
    document.getElementById('locationInput').value = state.location.name;
    document.getElementById('mapModal').classList.remove('show');
    updateMeta();
  });
  
  // Parallax tilt
  const preview = document.querySelector('.preview');
  const wrapper = document.getElementById('posterWrapper');
  preview.addEventListener('mousemove', e => {
    const rect = preview.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    animationState.parallaxX = x;
    animationState.parallaxY = y;
    wrapper.style.transform = `rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`;
  });
  preview.addEventListener('mouseleave', () => {
    animationState.parallaxX = 0;
    animationState.parallaxY = 0;
    wrapper.style.transform = 'rotateY(0) rotateX(0)';
  });
  
  // CTA — Shopify cart integration
  document.getElementById('addToCart').addEventListener('click', addToShopifyCart);
}

// =====================================================
// GEOCODING (Nominatim)
// =====================================================
async function searchLocation(query) {
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&accept-language=it`;
    const res = await fetch(url);
    const results = await res.json();
    showSuggestions(results);
  } catch (e) {
    console.error('Geocoding error:', e);
  }
}

function showSuggestions(results) {
  const container = document.getElementById('locationSuggestions');
  if (!results.length) {
    container.classList.remove('show');
    return;
  }
  container.innerHTML = results.map(r => 
    `<div class="location-suggestion" data-lat="${r.lat}" data-lon="${r.lon}" data-name="${r.display_name}">${r.display_name}</div>`
  ).join('');
  container.classList.add('show');
  
  container.querySelectorAll('.location-suggestion').forEach(el => {
    el.addEventListener('click', () => {
      state.location.lat = parseFloat(el.dataset.lat);
      state.location.lon = parseFloat(el.dataset.lon);
      state.location.name = el.dataset.name.split(',').slice(0, 2).join(',');
      document.getElementById('locationInput').value = state.location.name;
      container.classList.remove('show');
      updateMeta();
    });
  });
}

function updateMeta() {
  document.getElementById('metaLocation').textContent = state.location.name.toUpperCase();
  const lat = state.location.lat;
  const lon = state.location.lon;
  const latStr = `${Math.abs(lat).toFixed(2).replace('.', ',')}° ${lat >= 0 ? 'N' : 'S'}`;
  const lonStr = `${Math.abs(lon).toFixed(2).replace('.', ',')}° ${lon >= 0 ? 'E' : 'W'}`;
  document.getElementById('metaCoords').textContent = `${latStr} · ${lonStr}`;
  document.getElementById('metaDate').textContent = 
    `${state.date.day} ${MONTHS_IT[state.date.month-1].toUpperCase()} ${state.date.year}`;
}

// =====================================================
// MAP
// =====================================================
let mapInstance, mapMarker;
function setupMap() {
  mapInstance = L.map('map').setView([state.location.lat, state.location.lon], 5);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap'
  }).addTo(mapInstance);
  mapMarker = L.marker([state.location.lat, state.location.lon], { draggable: true }).addTo(mapInstance);
  
  mapMarker.on('dragend', e => {
    const p = e.target.getLatLng();
    state.location.lat = p.lat;
    state.location.lon = p.lng;
    updateCoordsDisplay();
  });
  mapInstance.on('click', e => {
    state.location.lat = e.latlng.lat;
    state.location.lon = e.latlng.lng;
    mapMarker.setLatLng(e.latlng);
    updateCoordsDisplay();
  });
}

function updateCoordsDisplay() {
  const lat = state.location.lat;
  const lon = state.location.lon;
  document.getElementById('coordsDisplay').textContent = 
    `${Math.abs(lat).toFixed(4).replace('.', ',')}° ${lat >= 0 ? 'N' : 'S'} · ${Math.abs(lon).toFixed(4).replace('.', ',')}° ${lon >= 0 ? 'E' : 'W'}`;
}

// =====================================================
// PRICING
// =====================================================
function updatePrice() {
  const price = PRICING[state.product][state.size];
  const priceEl = document.getElementById('priceValue');
  if (priceEl) priceEl.textContent = price.toFixed(2).replace('.', ',');

  // Aggiorna i prezzi su ogni size-card in base al product selezionato
  document.querySelectorAll('.size-card').forEach(card => {
    const size = card.dataset.size;
    if (!size || !PRICING[state.product] || !PRICING[state.product][size]) return;
    const p = PRICING[state.product][size];
    const priceSpan = card.querySelector('.size-price');
    if (priceSpan) priceSpan.textContent = p.toFixed(2).replace('.', ',') + ' €';
  });

  // Aggiorna i prezzi "da X €" sulle product card (Poster / Cornice / Metal)
  const minPoster = Math.min(...Object.values(PRICING.poster));
  const minFramed = Math.min(...Object.values(PRICING.framed));
  const minMetal  = Math.min(...Object.values(PRICING.metal));
  document.querySelectorAll('.product-card').forEach(card => {
    const type = card.dataset.product;
    const priceEl = card.querySelector('.product-price');
    if (!priceEl) return;
    if (type === 'poster') priceEl.textContent = 'da ' + minPoster.toFixed(2).replace('.', ',') + ' €';
    else if (type === 'framed') priceEl.textContent = 'da ' + minFramed.toFixed(2).replace('.', ',') + ' €';
    else if (type === 'metal') priceEl.textContent = 'da ' + minMetal.toFixed(2).replace('.', ',') + ' €';
  });
}

// =====================================================
// POSTER UI
// =====================================================
function updatePosterClass() {
  const poster = document.getElementById('poster');
  // Remove all color classes
  COLORS.forEach(c => poster.classList.remove(c.id));
  poster.classList.add(state.color);
}

// =====================================================
// ASTRONOMY: equatorial → horizontal
// =====================================================
function calculateStarPositions() {
  const dt = new Date(Date.UTC(
    state.date.year,
    state.date.month - 1,
    state.date.day,
    state.date.hour,
    state.date.minute
  ));
  
  const jd = (dt.getTime() / 86400000) + 2440587.5;
  const d = jd - 2451545.0;
  const gmst = ((18.697374558 + 24.06570982441908 * d) % 24 + 24) % 24;
  const lst = ((gmst + state.location.lon / 15) % 24 + 24) % 24;
  const lstRad = lst * 15 * Math.PI / 180;
  const latRad = state.location.lat * Math.PI / 180;
  const sinLat = Math.sin(latRad);
  const cosLat = Math.cos(latRad);
  
  const positions = new Array(STARS.length);
  
  // Scene modes usano sempre il limite globale (cielo più denso)
  const isSceneCalc = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');
  const magLimit = isSceneCalc ? MAG_LIMITS.global : MAG_LIMITS[state.viewMode];
  
  for (let i = 0; i < STARS.length; i++) {
    const [ra, dec, mag] = STARS[i];
    
    // Filtro magnitudine in base a vista locale/globale
    if (mag > magLimit) {
      positions[i] = null;
      continue;
    }
    
    const raRad = ra * 15 * Math.PI / 180;
    const decRad = dec * Math.PI / 180;
    const ha = lstRad - raRad;
    
    const sinDec = Math.sin(decRad);
    const cosDec = Math.cos(decRad);
    const sinAlt = sinDec * sinLat + cosDec * cosLat * Math.cos(ha);
    
    if (sinAlt <= 0) {
      positions[i] = null;
      continue;
    }
    
    const alt = Math.asin(sinAlt);
    const cosAlt = Math.cos(alt);
    let cosAz = (sinDec - sinAlt * sinLat) / (cosAlt * cosLat);
    cosAz = Math.max(-1, Math.min(1, cosAz));
    let az = Math.acos(cosAz);
    if (Math.sin(ha) > 0) az = 2 * Math.PI - az;
    
    positions[i] = { alt, az, mag };
  }
  
  return { positions, lstRad, latRad, sinLat, cosLat };
}

// Project alt/az to canvas (stereographic)
function project(alt, az, cx, cy, radius) {
  const r = radius * Math.tan((Math.PI/2 - alt) / 2);
  if (r > radius) return null;
  return {
    x: cx + r * Math.sin(az),
    y: cy - r * Math.cos(az),
    r,
  };
}

// =====================================================
// SHAPE PATHS — supports morphing via interpolation
// =====================================================
function getShapePoints(shape, cx, cy, r, n = 360) {
  // 'sunset' e 'couple' usano un rettangolo come clip
  const useRect = (shape === 'sunset' || shape === 'couple');
  const pts = [];
  for (let i = 0; i < n; i++) {
    const t = (i / n) * Math.PI * 2;
    let x, y;
    if (shape === 'heart') {
      const scale = r / 18;
      x = cx + scale * 16 * Math.pow(Math.sin(t), 3);
      y = cy - scale * (13 * Math.cos(t) - 5 * Math.cos(2*t) - 2 * Math.cos(3*t) - Math.cos(4*t)) + scale * 2;
    } else if (useRect) {
      // Rettangolo arrotondato (per scene)
      const ax = Math.abs(Math.cos(t));
      const ay = Math.abs(Math.sin(t));
      const m = Math.max(ax, ay);
      x = cx + r * 0.98 * Math.cos(t) / m;
      y = cy + r * 0.98 * Math.sin(t) / m;
    } else {
      // circle (default)
      x = cx + r * Math.cos(t);
      y = cy + r * Math.sin(t);
    }
    pts.push([x, y]);
  }
  return pts;
}

function lerp(a, b, t) { return a + (b - a) * t; }

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function getMorphedPath(cx, cy, r) {
  if (!animationState.morphing) {
    return getShapePoints(state.shape, cx, cy, r);
  }
  const t = easeInOutCubic(animationState.shapeMorph);
  const from = getShapePoints(animationState.fromShape, cx, cy, r);
  const to = getShapePoints(animationState.toShape, cx, cy, r);
  return from.map((p, i) => [
    lerp(p[0], to[i][0], t),
    lerp(p[1], to[i][1], t),
  ]);
}

function drawShapeFromPath(ctx, points) {
  ctx.beginPath();
  ctx.moveTo(points[0][0], points[0][1]);
  for (let i = 1; i < points.length; i++) {
    ctx.lineTo(points[i][0], points[i][1]);
  }
  ctx.closePath();
}

// =====================================================
// RENDER LOOP
// =====================================================
let lastTime = 0;
let cachedPositions = null;
let lastDateKey = '';

function startRenderLoop() {
  function loop(time) {
    const dt = time - lastTime;
    lastTime = time;
    
    // Update animation state
    if (animationState.fadingIn) {
      animationState.starOpacity = Math.min(1, animationState.starOpacity + dt / 1500);
      if (animationState.starOpacity >= 1) animationState.fadingIn = false;
    }
    if (animationState.starFading) {
      animationState.starFadeOpacity = Math.max(0, animationState.starFadeOpacity - dt / 250);
    }
    
    if (animationState.morphing) {
      animationState.shapeMorph = Math.min(1, animationState.shapeMorph + dt / 700);
      if (animationState.shapeMorph >= 1) animationState.morphing = false;
    }
    
    // Recalculate positions only when date/location/viewMode changes
    const dateKey = `${state.date.year}-${state.date.month}-${state.date.day}-${state.date.hour}-${state.date.minute}-${state.location.lat}-${state.location.lon}-${state.viewMode}`;
    if (dateKey !== lastDateKey) {
      cachedPositions = calculateStarPositions();
      lastDateKey = dateKey;
    }
    
    render(time);
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
}

// =====================================================
// MAIN RENDER
// =====================================================
function render(time) {
  if (!cachedPositions) return;
  
  const canvas = document.getElementById('sky');
  const ctx = canvas.getContext('2d');
  const w = canvas.width;
  const h = canvas.height;
  const cx = w / 2;
  const cy = h / 2;
  // In scene mode usiamo radius più grande per riempire il cielo full-width
  const isSceneShape = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');
  const radius = isSceneShape ? Math.max(w, h) * 0.75 : Math.min(w, h) / 2 - 4;
  
  updatePosterClass();
  updateMeta();
  
  ctx.clearRect(0, 0, w, h);
  
  const bgColor = COLORS.find(c => c.id === state.color).swatch;
  const isLight = state.color === 'cream';
  const starColor = isLight ? '#1a1a1a' : '#ffffff';
  const lineColor = isLight ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.45)';
  const nameColor = isLight ? 'rgba(0,0,0,0.55)' : 'rgba(255,255,255,0.6)';
  
  const isScene = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');
  // Orizzonte scena: stelle/costellazioni stanno SOPRA questa Y
  // Sunset: cielo arriva fino alla banda arancio (~ 70% dell'immagine)
  // Couple: cielo arriva fino alla collina (~ 76%)
  // Stelle solo sopra l'orizzonte della foto (sunset banda arancio, couple collina)
  // Sunset: taglio hard + fade. Couple: nessun taglio Y, la silhouette mask copre gli omini.
  const sceneHorizonY = state.shape === 'sunset' ? h * 0.66 : h;
  
  if (isScene) {
    // ===== SCENE MODE: full-bleed, no shape clip =====
    drawSceneBackground(ctx, w, h);
    
    if (state.options.milkyWay) {
      drawMilkyWay(ctx, cx, cy, radius, false);
    }
    
    ctx.save();
    // (foreground disegnato dopo le stelle/costellazioni)
  } else {
    // ===== SHAPE MODE (cerchio/cuore/frameless): clip dentro la forma =====
    const shapePoints = getMorphedPath(cx, cy, radius);
    ctx.save();
    drawShapeFromPath(ctx, shapePoints);
    // Frameless: nessun riempimento, le stelle si fondono col poster background
    if (state.shape !== 'frameless') {
      ctx.fillStyle = bgColor;
      ctx.fill();
    }
    ctx.clip();
    
    if (state.options.milkyWay) {
      drawMilkyWay(ctx, cx, cy, radius, isLight);
    }
    if (state.options.grid) {
      drawCoordinateGrid(ctx, cx, cy, radius, lineColor);
    }
  }
  
  // ----- STARS -----
  const { positions } = cachedPositions;
  const fadeMultiplier = animationState.starFading ? animationState.starFadeOpacity : 1;
  const opacity = animationState.starOpacity * fadeMultiplier;

  ctx.fillStyle = isScene ? '#ffffff' : starColor;
  
  for (let i = 0; i < positions.length; i++) {
    const p = positions[i];
    if (!p) continue;
    
    const proj = project(p.alt, p.az, cx, cy, radius);
    if (!proj) continue;
    
    // Sunset: taglio hard all'orizzonte. Couple: nessun taglio (silhouette mask).
    if (isScene && proj.y >= sceneHorizonY) continue;

    // Magnitude → radius (limitato per evitare blob giganti)
    const mag = p.mag;
    const sizeScale = isScene ? 1.1 : (radius / 140);
    let r = Math.max(0.3, Math.min(isScene ? 2.8 : 3.5, 6 * (7.5 - mag) / 16 * sizeScale));

    // Twinkle effect on bright stars: solo bagliori in più (mai più scure)
    let starAlpha = opacity;
    let twinkleBoost = 0;
    if (state.options.twinkle && mag < 3.5) {
      const phase = animationState.twinklePhases[i] + time / 1200;
      // Da 0 a 0.4: alpha più alta nei picchi, mai più bassa del normale
      twinkleBoost = Math.max(0, Math.sin(phase)) * 0.35;
      starAlpha = Math.min(1, opacity * (1 + twinkleBoost));
    }
    
    // Sequential fade-in: brighter stars appear first (solo nelle forme non-scene)
    if (!isScene && animationState.starOpacity < 1) {
      const threshold = (mag + 1) / 7.5; // 0..1
      if (animationState.starOpacity < threshold) continue;
    }
    
    // Tramonto: fade graduale delle stelle verso l'orizzonte (zona 75px sopra il taglio)
    if (state.shape === 'sunset') {
      const fadeZone = 75;
      const fadeStart = sceneHorizonY - fadeZone;
      if (proj.y > fadeStart) {
        starAlpha *= 1 - (proj.y - fadeStart) / fadeZone;
        if (starAlpha <= 0.01) continue;
      }
    }

    // Cielo pieno: fade nella zona testo in basso
    if (state.shape === 'fullsky') {
      const fadeZone = 140;
      const fadeStart = h - fadeZone;
      if (proj.y > fadeStart) {
        starAlpha *= 1 - (proj.y - fadeStart) / fadeZone;
        if (starAlpha <= 0.01) continue;
      }
    }

    ctx.globalAlpha = starAlpha;
    ctx.beginPath();
    ctx.arc(proj.x, proj.y, r, 0, Math.PI * 2);
    ctx.fill();

    // Glow sulle stelle brillanti — solo nelle forme standard, non scene
    if (!isScene && mag < 1.5) {
      const glowStrength = (1.5 - mag) / 1.5;
      ctx.globalAlpha = starAlpha * 0.18 * glowStrength;
      ctx.beginPath();
      ctx.arc(proj.x, proj.y, r * 2.0, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  ctx.globalAlpha = 1;
  
  // ----- CONSTELLATIONS -----
  const constLineColor = isScene ? 'rgba(255,255,255,0.88)' : lineColor;
  const constYLimit = state.shape === 'fullsky' ? h - 100 : (isScene ? sceneHorizonY : Infinity);
  if (state.options.constellations) {
    drawConstellations(ctx, cx, cy, radius, constLineColor, opacity, constYLimit);
  }
  
  if (state.options.constellationNames) {
    drawConstellationNames(ctx, cx, cy, radius, isScene ? 'rgba(255,255,255,0.7)' : nameColor, opacity, constYLimit);
  }
  
  ctx.restore();
  
  if (isScene && state.shape !== 'fullsky') {
    // ----- FOREGROUND (maschera bassa + silhouette) -----
    drawSceneForeground(ctx, w, h);
  } else if (state.shape !== 'frameless') {
    // ----- SHAPE OUTLINE (omesso per frameless: si fonde col background) -----
    const shapePoints = getMorphedPath(cx, cy, radius);
    ctx.save();
    drawShapeFromPath(ctx, shapePoints);
    ctx.strokeStyle = isLight ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.85)';
    ctx.lineWidth = 1.2;
    ctx.stroke();
    ctx.restore();
  }
  
  updatePrice();
}

// =====================================================
// CONSTELLATION RENDERING
// =====================================================
function drawConstellations(ctx, cx, cy, radius, color, opacity, yLimit = Infinity) {
  const { lstRad, sinLat, cosLat } = cachedPositions;
  const isSceneMode = (state.shape === 'sunset' || state.shape === 'couple' || state.shape === 'fullsky');

  // STEP 1: linee costellazioni
  ctx.strokeStyle = color;
  ctx.lineWidth = isSceneMode ? 0.7 : 0.5;
  ctx.globalAlpha = opacity * (isSceneMode ? 0.42 : 0.5);
  
  // Raccolgo i vertici visibili per disegnare pallini dopo
  const vertices = [];
  
  for (const constell of CONSTELLATION_LINES) {
    for (const path of constell.paths) {
      ctx.beginPath();
      let started = false;
      let lastVisible = false;
      
      for (const [raH, dec] of path) {
        const raRad = raH * 15 * Math.PI / 180;
        const decRad = dec * Math.PI / 180;
        const ha = lstRad - raRad;
        const sinDec = Math.sin(decRad);
        const cosDec = Math.cos(decRad);
        const sinAlt = sinDec * sinLat + cosDec * cosLat * Math.cos(ha);
        
        if (sinAlt <= 0) {
          lastVisible = false;
          continue;
        }
        
        const alt = Math.asin(sinAlt);
        const cosAlt = Math.cos(alt);
        let cosAz = (sinDec - sinAlt * sinLat) / (cosAlt * cosLat);
        cosAz = Math.max(-1, Math.min(1, cosAz));
        let az = Math.acos(cosAz);
        if (Math.sin(ha) > 0) az = 2 * Math.PI - az;
        
        const proj = project(alt, az, cx, cy, radius);
        if (!proj || proj.y > yLimit) {
          lastVisible = false;
          continue;
        }
        
        if (!started || !lastVisible) {
          ctx.moveTo(proj.x, proj.y);
          started = true;
        } else {
          ctx.lineTo(proj.x, proj.y);
        }
        vertices.push([proj.x, proj.y]);
        lastVisible = true;
      }
      ctx.stroke();
    }
  }
  
  // STEP 2: pallini sui vertici — più grandi nelle scene mode
  ctx.fillStyle = color.replace(/[\d.]+\)$/, '0.9)');
  ctx.globalAlpha = opacity;
  for (const [x, y] of vertices) {
    ctx.beginPath();
    ctx.arc(x, y, isSceneMode ? 1.2 : 1.0, 0, Math.PI * 2);
    ctx.fill();
  }
  
  ctx.globalAlpha = 1;
}

function drawConstellationNames(ctx, cx, cy, radius, color, opacity, yLimit = Infinity) {
  const { lstRad, sinLat, cosLat } = cachedPositions;
  
  ctx.fillStyle = color;
  ctx.font = '500 9px Poppins, sans-serif';
  ctx.textAlign = 'center';
  ctx.globalAlpha = opacity * 0.85;
  
  for (const c of CONSTELLATION_NAMES) {
    const raRad = c.ra * 15 * Math.PI / 180;
    const decRad = c.dec * Math.PI / 180;
    const ha = lstRad - raRad;
    const sinDec = Math.sin(decRad);
    const cosDec = Math.cos(decRad);
    const sinAlt = sinDec * sinLat + cosDec * cosLat * Math.cos(ha);
    
    if (sinAlt <= 0.05) continue; // skip near-horizon
    
    const alt = Math.asin(sinAlt);
    const cosAlt = Math.cos(alt);
    let cosAz = (sinDec - sinAlt * sinLat) / (cosAlt * cosLat);
    cosAz = Math.max(-1, Math.min(1, cosAz));
    let az = Math.acos(cosAz);
    if (Math.sin(ha) > 0) az = 2 * Math.PI - az;
    
    const proj = project(alt, az, cx, cy, radius);
    if (!proj || proj.r > radius * 0.9) continue;
    if (proj.y > yLimit) continue;
    
    ctx.fillText(c.name.toUpperCase(), proj.x, proj.y);
  }
  ctx.globalAlpha = 1;
  ctx.textAlign = 'start';
}

// =====================================================
// COORDINATE GRID
// =====================================================
function drawCoordinateGrid(ctx, cx, cy, r, color) {
  ctx.strokeStyle = color;
  ctx.lineWidth = 0.4;
  for (let i = 1; i <= 4; i++) {
    ctx.beginPath();
    ctx.arc(cx, cy, r * i / 4, 0, Math.PI * 2);
    ctx.stroke();
  }
  for (let i = 0; i < 12; i++) {
    const angle = (i * 30) * Math.PI / 180;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + r * Math.cos(angle), cy + r * Math.sin(angle));
    ctx.stroke();
  }
}

// =====================================================
// SCENE FULL-BLEED — sunset/couple usano immagini IA come sfondo
// + costellazioni Momenterie style sopra il cielo
// =====================================================
let sunsetBgImage = null;
let coupleBgImage = null;
let coupleTopLayer = null; // silhouette-only layer: pixel scuri opachi, cielo trasparente

function loadSceneImages() {
  const ASSETS = window.STARMAP_ASSETS || {};
  sunsetBgImage = new Image();
  sunsetBgImage.crossOrigin = 'anonymous';
  sunsetBgImage.onload = () => { /* il render loop ridisegnerà da solo */ };
  sunsetBgImage.src = ASSETS.sunset || 'sunset_real.jpg';
  coupleBgImage = new Image();
  coupleBgImage.crossOrigin = 'anonymous';
  coupleBgImage.onload = () => { preprocessCoupleTopLayer(); };
  coupleBgImage.src = ASSETS.couple || 'couple_real.jpg';
}

// Estrae la silhouette dalla foto coppia: pixel con luminosità < soglia restano opachi,
// il cielo (pixel più chiari) diventa trasparente. Eseguito una volta sola al caricamento.
function preprocessCoupleTopLayer() {
  if (!coupleBgImage?.complete || !coupleBgImage.naturalWidth) return;
  const w = 380, h = 570;
  const temp = document.createElement('canvas');
  temp.width = w; temp.height = h;
  const tempCtx = temp.getContext('2d', { willReadFrequently: true });
  const ir = coupleBgImage.naturalWidth / coupleBgImage.naturalHeight;
  const cr = w / h;
  let dw, dh, dx, dy;
  if (ir > cr) { dh = h; dw = h * ir; dx = (w - dw) / 2; dy = 0; }
  else { dw = w; dh = w / ir; dx = 0; dy = (h - dh) / 2; }
  // Over-extend 12px per lato per evitare bordi rovinati
  tempCtx.drawImage(coupleBgImage, dx - 12, dy - 12, dw + 24, dh + 24);
  const id = tempCtx.getImageData(0, 0, w, h);
  const d = id.data;
  // La silhouette esiste solo nella zona bassa (60% in giù).
  // Sopra è sempre cielo → forziamo trasparente per non coprire stelle/costellazioni.
  const silhouetteStartY = Math.round(h * 0.55);
  for (let i = 0; i < d.length; i += 4) {
    const pxIdx = i / 4;
    const y = Math.floor(pxIdx / w);
    const maxChan = Math.max(d[i], d[i+1], d[i+2]);
    if (y < silhouetteStartY) {
      // Zona alta = sempre cielo
      d[i+3] = 0;
    } else if (maxChan > 18) {
      // Zona bassa ma non nero → cielo
      d[i+3] = 0;
    }
    // Zona bassa + nero → silhouette opaca (resta com'è)
  }
  tempCtx.putImageData(id, 0, 0);
  coupleTopLayer = temp;
}

function drawSceneBackground(ctx, w, h) {
  if (state.shape === 'fullsky') {
    ctx.fillStyle = COLORS.find(c => c.id === state.color).swatch;
    ctx.fillRect(0, 0, w, h);
    return;
  }
  // Sfondo nero come safety net (evita righe bianche se la foto non copre)
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, w, h);
  const img = (state.shape === 'sunset') ? sunsetBgImage : coupleBgImage;
  // Fallback: cielo gradient mentre l'immagine carica
  if (!img || !img.complete || !img.naturalWidth) {
    const g = ctx.createLinearGradient(0, 0, 0, h);
    g.addColorStop(0, '#050a1a');
    g.addColorStop(1, '#15264a');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    return;
  }
  // Cover-fit (riempie sempre tutto il canvas, croppando se necessario)
  const ir = img.naturalWidth / img.naturalHeight;
  const cr = w / h;
  let dw, dh, dx, dy;
  if (ir > cr) {
    dh = h; dw = h * ir; dx = (w - dw) / 2; dy = 0;
  } else {
    dw = w; dh = w / ir; dx = 0; dy = (h - dh) / 2;
  }
  // Sovra-estendo di 12px ogni lato per eliminare bordi chiari/rovinati della foto
  ctx.drawImage(img, dx - 12, dy - 12, dw + 24, dh + 24);
}

function drawSceneForeground(ctx, w, h) {
  // Per coppia: sovrappone solo i pixel scuri (silhouette) estratti al caricamento.
  // Il cielo nel layer è trasparente → stelle visibili accanto agli omini.
  if (state.shape === 'couple') {
    if (coupleTopLayer) {
      ctx.drawImage(coupleTopLayer, 0, 0);
    } else if (coupleBgImage?.complete && coupleBgImage.naturalWidth) {
      // Fallback finché il preprocessing non è pronto
      const img = coupleBgImage;
      const ir = img.naturalWidth / img.naturalHeight;
      const cr = w / h;
      let dw, dh, dx, dy;
      if (ir > cr) { dh = h; dw = h * ir; dx = (w - dw) / 2; dy = 0; }
      else { dw = w; dh = w / ir; dx = 0; dy = (h - dh) / 2; }
      ctx.save();
      ctx.beginPath();
      ctx.rect(0, h * 0.55, w, h * 0.45);
      ctx.clip();
      ctx.drawImage(img, dx - 12, dy - 12, dw + 24, dh + 24);
      ctx.restore();
    }
  }

  // Gradient scuro in basso per dare respiro al testo e separarlo dall'immagine.
  // Il gradient in alto è rimosso perché creava una striscia brutta.
  const gradStart = state.shape === 'sunset' ? h * 0.58 : h * 0.60;
  const bot = ctx.createLinearGradient(0, gradStart, 0, h);
  bot.addColorStop(0, 'rgba(0,0,0,0)');
  bot.addColorStop(1, 'rgba(0,0,0,0.82)');
  ctx.fillStyle = bot;
  ctx.fillRect(0, gradStart, w, h - gradStart);
}


// =====================================================
// MILKY WAY — 5-layer realistic band
// =====================================================
function drawMilkyWay(ctx, cx, cy, r, isLight) {
  const { lstRad, sinLat, cosLat } = cachedPositions;
  
  // The Milky Way galactic plane has galactic latitude ≈ 0
  // Approximate galactic equator points (RA, Dec) sampled
  // Galactic plane direction: a great circle tilted ~63° to celestial equator
  const galacticPoints = [];
  for (let i = 0; i < 360; i++) {
    const l = i * Math.PI / 180; // galactic longitude
    // Convert galactic to equatorial (J2000)
    // Galactic North Pole: RA=192.86°, Dec=27.13°
    const sinB = 0; // we want b=0, points on galactic equator
    const cosB = 1;
    const sinL = Math.sin(l);
    const cosL = Math.cos(l);
    
    // Standard galactic-to-equatorial transformation
    const RA_NGP = 192.86 * Math.PI / 180;
    const DEC_NGP = 27.13 * Math.PI / 180;
    const L_NCP = 122.93 * Math.PI / 180;
    
    const sinDec = Math.sin(DEC_NGP) * sinB + Math.cos(DEC_NGP) * cosB * Math.cos(L_NCP - l);
    const dec = Math.asin(sinDec);
    const cosDec = Math.cos(dec);
    const sinRaMa = cosB * Math.sin(L_NCP - l) / cosDec;
    const cosRaMa = (Math.cos(DEC_NGP) * sinB - Math.sin(DEC_NGP) * cosB * Math.cos(L_NCP - l)) / cosDec;
    const ra = RA_NGP + Math.atan2(sinRaMa, cosRaMa);
    
    galacticPoints.push({ ra, dec });
  }
  
  // Draw 5 concentric "bands" of dots with varying opacity
  const layers = [
    { spread: 0.05, density: 800, opacity: 0.08 },
    { spread: 0.10, density: 600, opacity: 0.06 },
    { spread: 0.18, density: 500, opacity: 0.04 },
    { spread: 0.28, density: 400, opacity: 0.03 },
    { spread: 0.40, density: 300, opacity: 0.02 },
  ];
  
  ctx.fillStyle = isLight ? '#000' : '#ffffff';
  
  for (const layer of layers) {
    ctx.globalAlpha = layer.opacity;
    
    // Pseudo-random but deterministic dots along galactic plane
    let seed = 12345;
    const rng = () => {
      seed = (seed * 1664525 + 1013904223) >>> 0;
      return (seed / 0xffffffff);
    };
    
    for (let i = 0; i < layer.density; i++) {
      const idx = Math.floor(rng() * galacticPoints.length);
      const offsetB = (rng() - 0.5) * 2 * layer.spread; // perpendicular offset
      
      const baseRa = galacticPoints[idx].ra;
      const baseDec = galacticPoints[idx].dec;
      const dec = baseDec + offsetB;
      const ra = baseRa;
      
      // Convert to alt/az
      const ha = lstRad - ra;
      const sinDec = Math.sin(dec);
      const cosDec = Math.cos(dec);
      const sinAlt = sinDec * sinLat + cosDec * cosLat * Math.cos(ha);
      if (sinAlt <= 0) continue;
      const alt = Math.asin(sinAlt);
      const cosAlt = Math.cos(alt);
      let cosAz = (sinDec - sinAlt * sinLat) / (cosAlt * cosLat);
      cosAz = Math.max(-1, Math.min(1, cosAz));
      let az = Math.acos(cosAz);
      if (Math.sin(ha) > 0) az = 2 * Math.PI - az;
      
      const proj = project(alt, az, cx, cy, r);
      if (!proj) continue;
      
      ctx.beginPath();
      ctx.arc(proj.x, proj.y, 0.6, 0, Math.PI * 2);
      ctx.fill();
    }
  }
  ctx.globalAlpha = 1;
}

// =====================================================
// SHOPIFY CART INTEGRATION
// =====================================================
const SIZE_LABEL = {
  '30x40': '30 × 40 cm',
  '45x60': '45 × 60 cm',
  '50x70': '50 × 70 cm',
  '60x80': '60 × 80 cm',
};

const PRODUCT_LABEL = {
  poster: 'Poster Fine Art',
  framed: 'Con cornice in legno',
  metal: 'Cornice in metallo',
};

function formatStarmapDate(d) {
  const month = MONTHS_IT[d.month - 1] || '';
  let s = `${d.day} ${month} ${d.year}`;
  if (d.hour !== null && d.hour !== undefined) {
    const hh = String(d.hour).padStart(2, '0');
    const mm = String(d.minute || 0).padStart(2, '0');
    s += ` alle ${hh}:${mm}`;
  }
  return s;
}

function formatCoords(lat, lon) {
  const ns = lat >= 0 ? 'N' : 'S';
  const ew = lon >= 0 ? 'E' : 'O';
  return `${Math.abs(lat).toFixed(4)}° ${ns} · ${Math.abs(lon).toFixed(4)}° ${ew}`;
}

// =====================================================
// FRAME COLOR & DELIVERY DATE UTILITIES
// =====================================================
const FRAME_COLOR_LABEL = {
  naturale: 'Naturale',
  bianco: 'Bianco',
  nero: 'Nero',
};

const ITALIAN_MONTHS_SHORT = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];

function toggleFrameColorField() {
  const field = document.getElementById('frameColorField');
  if (!field) return;
  if (state.product === 'framed') {
    field.style.removeProperty('display');
  } else {
    field.style.setProperty('display', 'none', 'important');
  }
}

function updatePosterFrame() {
  const poster = document.getElementById('poster');
  if (!poster) return;
  const FRAME_CLASSES = ['has-frame-naturale', 'has-frame-bianco', 'has-frame-nero', 'has-frame-metal'];
  const wasFramed = FRAME_CLASSES.some(c => poster.classList.contains(c));

  FRAME_CLASSES.forEach(c => poster.classList.remove(c));

  let newFrameClass = null;
  if (state.product === 'framed') newFrameClass = 'has-frame-' + state.frameColor;
  else if (state.product === 'metal') newFrameClass = 'has-frame-metal';

  if (newFrameClass) {
    poster.classList.add(newFrameClass);
    // Pulse animation solo quando la cornice APPARE (no→sì), non al cambio colore
    if (!wasFramed) {
      poster.classList.remove('frame-just-arrived');
      void poster.offsetWidth; // force reflow
      poster.classList.add('frame-just-arrived');
    }
  } else {
    // Tornando a Poster (no cornice), tolgo anche la classe d'animazione
    poster.classList.remove('frame-just-arrived');
  }
}

function addWorkingDays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dow = result.getDay(); // 0 = Dom, 6 = Sab
    if (dow !== 0 && dow !== 6) added++;
  }
  return result;
}

function formatDeliveryRange(daysMin, daysMax) {
  const today = new Date();
  const dMin = addWorkingDays(today, daysMin);
  const dMax = addWorkingDays(today, daysMax);
  const sameMonth = dMin.getMonth() === dMax.getMonth();
  if (sameMonth) {
    return `dal ${dMin.getDate()} al ${dMax.getDate()} ${ITALIAN_MONTHS_SHORT[dMax.getMonth()]}`;
  }
  return `dal ${dMin.getDate()} ${ITALIAN_MONTHS_SHORT[dMin.getMonth()]} al ${dMax.getDate()} ${ITALIAN_MONTHS_SHORT[dMax.getMonth()]}`;
}

function updateDeliveryDates() {
  const posterEl = document.querySelector('[data-delivery="poster"]');
  const framedEl = document.querySelector('[data-delivery="framed"]');
  const metalEl  = document.querySelector('[data-delivery="metal"]');
  if (posterEl) posterEl.textContent = 'Consegna ' + formatDeliveryRange(3, 5);
  if (framedEl) framedEl.textContent = 'Consegna ' + formatDeliveryRange(5, 7);
  if (metalEl)  metalEl.textContent  = 'Consegna ' + formatDeliveryRange(4, 6);
}

async function addToShopifyCart() {
  const VARIANT_IDS = window.STARMAP_VARIANT_IDS || {};
  let tipoKey;
  if (state.product === 'framed') tipoKey = `framed-${state.frameColor}`;
  else if (state.product === 'metal') tipoKey = 'metal';
  else tipoKey = 'poster';
  const key = `${tipoKey}-${state.size}`;
  const variantId = VARIANT_IDS[key];

  if (!variantId) {
    alert('Variante non configurata: ' + key + '. Contattaci a infokurigadget@gmail.com.');
    return;
  }

  // Pull live values from inputs
  const titleEl = document.getElementById('titleText');
  const dedicationEl = document.getElementById('dedicationText');
  const title = (titleEl && titleEl.value.trim()) || state.title || '';
  const dedication = (dedicationEl && dedicationEl.value.trim()) || '';

  const shapeLabel = (SHAPES.find(s => s.id === state.shape) || {}).label || state.shape;

  const tipoLabel = state.product === 'framed'
    ? `Con cornice in legno (${FRAME_COLOR_LABEL[state.frameColor] || state.frameColor})`
    : (PRODUCT_LABEL[state.product] || state.product);

  const properties = {
    'Formato': SIZE_LABEL[state.size] || state.size,
    'Tipo': tipoLabel,
    'Data': formatStarmapDate(state.date),
    'Luogo': state.location.name,
    'Coordinate': formatCoords(state.location.lat, state.location.lon),
    'Forma': shapeLabel,
    'Colore sfondo': state.color,
    'Vista cielo': state.viewMode === 'global' ? 'Globale' : 'Locale',
    'Costellazioni': state.options.constellations ? 'Sì' : 'No',
    'Griglia coordinate': state.options.grid ? 'Sì' : 'No',
    'Mostra coordinate stampa': state.options.showCoords ? 'Sì' : 'No',
    'Titolo': title,
  };
  if (dedication) properties['Dedica'] = dedication;
  if (state.product === 'framed') {
    properties['Colore cornice'] = FRAME_COLOR_LABEL[state.frameColor] || state.frameColor;
  }

  const fwdBtn = document.getElementById('navForward');
  const originalHTML = fwdBtn.innerHTML;
  fwdBtn.disabled = true;
  fwdBtn.textContent = 'Salvataggio…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: properties }],
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Errore durante l\'aggiunta al carrello');
    }

    window.location.href = '/cart';
  } catch (e) {
    console.error('[starmap] cart error:', e);
    alert('Errore: ' + e.message);
    fwdBtn.disabled = false;
    fwdBtn.innerHTML = originalHTML;
  }
}

// =====================================================
// LAUNCH
// =====================================================
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})(); // end IIFE
